const formatTelephoneNumber = (phoneNumber, country) => {
  // Remove anything that is not a number
  let telNumber = phoneNumber.replace(/\D/g, '');

  // Remove leading 0 if it exists
  if (telNumber.startsWith('0')) {
    telNumber = telNumber.slice(1);
  }

  // Add country code based on country
  telNumber = country === 'Australia' ? "+61".concat(telNumber) : "+64".concat(telNumber);
  return telNumber;
};
export default formatTelephoneNumber;